import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { MUser } from '@argalis-apps/models';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ags-deconnexion',
  templateUrl: './deconnexion.component.html',
  styleUrls: ['./deconnexion.component.scss']
})
export class DeconnexionComponent implements OnInit, OnDestroy {
  @HostBinding('class') themeFlag: string;
  @Input('landingRoute')
  set _landingRoute(value: string[]) {
    this.landingRoute = value;
  }

  @Input('hiddenHtml')
  set _hiddenHtml(value: boolean) {
    this.hiddenHtml = value;
  }

  landingRoute: string[];
  hiddenHtml: boolean;

  public userConnected: MUser.CUser = null;
  private authServiceSubscriber: Subscription;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.userConnected = this.authService.userConnected || null;
    this.authServiceSubscriber = this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
  }

  ngOnDestroy() {
    this.authServiceSubscriber.unsubscribe();
  }

  async signout() {
    await this.authService.signoutAndNavigate(this.landingRoute);
  }
}
